import { render, staticRenderFns } from "./SolidRingForResultForMobile.vue?vue&type=template&id=08ec551c&scoped=true"
import script from "./SolidRingForResultForMobile.vue?vue&type=script&lang=js"
export * from "./SolidRingForResultForMobile.vue?vue&type=script&lang=js"
import style0 from "./SolidRingForResultForMobile.vue?vue&type=style&index=0&id=08ec551c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec551c",
  null
  
)

export default component.exports